module.exports = __webpack_public_path__ + "static/assets/e650596fbf2bfc83b648c3af91f10bfe.png";